import { createAdminApi, type AdminApi } from './admin-api';
import { createAiSettingsApi, type AiSettingsApi } from './ai-settings-api';
import { createAuthApi, type ApiClientOptions, type AuthApi } from './auth-api';

/** Clientes de la configuracion (sesion, conexiones y publicacion, asistente de IA). */
export interface AdminServices {
  readonly auth: AuthApi;
  readonly admin: AdminApi;
  readonly aiSettings: AiSettingsApi;
}

export function createAdminServices(options: ApiClientOptions): AdminServices {
  return {
    auth: createAuthApi(options),
    admin: createAdminApi(options),
    aiSettings: createAiSettingsApi(options),
  };
}
